import { cx } from '@linaria/core'
import { BodyText, Button, ButtonGroup, elFlex1, elHFull, elMt8, FlexContainer } from '@reapit/elements'
import { DialogWrapper } from '@reapitform/common-ui'
import { IDocuments } from '@reapitform/dashboard-ui'
import React from 'react'

interface IUnableToSendProps {
  isOpen?: boolean
  onClose?: () => void
  agreementStatus?: IDocuments['status']
}

const ERROR_MESSAGES: { [key: string]: string } = {
  Draft:
    "There are some required fields still need to be completed before you can send this agreement. Check the orange messages to see what's missing.",
  Blocked: 'All change requests must be resolved before sending the lease for signing.',
}

export const UnableToSendModal: React.FC<IUnableToSendProps> = ({ isOpen = false, onClose, agreementStatus }) => {
  const message: string = ERROR_MESSAGES[agreementStatus ?? 'Draft'] ?? ERROR_MESSAGES.Draft

  return (
    <DialogWrapper handlerModalClose={() => onClose?.()} isModalOpen={isOpen} title="Unable to Send">
      <form>
        <FlexContainer isFlexColumn className={cx(elHFull, elFlex1)}>
          <BodyText>{message}</BodyText>
          <ButtonGroup alignment="right" className={cx(elMt8)}>
            <Button intent="primary" onClick={onClose}>
              Got it, thanks
            </Button>
          </ButtonGroup>
        </FlexContainer>
      </form>
    </DialogWrapper>
  )
}
